import { ImageResource, LaravelResponse, keyToUrl } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { mapContactAttributeToProfileHandler } from "../contacts/profile/profileContactAttributeMapper";
import { ContactAttributeFormResource } from "../types/contactAttribute";

const showKey = ["me", "profile"];

export interface ProfileResource {
	image: ImageResource | null;
	attributes: ContactAttributeFormResource[];
}

export const profileService = {
	showKey,
	show: () => axios.get<LaravelResponse<ProfileResource>>(keyToUrl(showKey)),
	update: (values: any) => axios.put(keyToUrl(showKey), values),
};

export function useProfile() {
	const { data, isLoading } = useQuery({
		queryKey: profileService.showKey,
		queryFn: () =>
			profileService.show().then((r) => ({
				image: r.data.data.image,
				attributes: r.data.data.attributes.map((a) => mapContactAttributeToProfileHandler(a)),
			})),
	});

	return {
		profile: data,
		isLoading,
	};
}
